import { useRef, useCallback } from 'react';
import type { AnimatedSvgRef } from '../Button.types';

export function useIconAnimation(isDisabled: boolean) {
  const iconAnimatedRef = useRef<AnimatedSvgRef>(null);

  const onAnimationForward = useCallback(() => {
    !isDisabled && iconAnimatedRef.current?.runAnimationForward();
  }, [isDisabled]);

  const onAnimationBackward = useCallback(() => {
    !isDisabled && iconAnimatedRef.current?.runAnimationBackward();
  }, [isDisabled]);

  return { iconAnimatedRef, onAnimationForward, onAnimationBackward };
}
